import React, { useContext, useEffect, useRef, useState } from "react";
import ProductContext from "../contexts/ProductContext";
import "./styles.scss";

const CustomAutoComplete = ({ items, defaultValue }) => {
  const [display, setDisplay] = useState(false);
  const [options, setOptions] = useState([]);
  const context = useContext(ProductContext);
  const { fetchDataByKeyward, setKeyword, swiperRef, oldKeyward } = context;
  const [search, setSearch] = useState(oldKeyward);
  const wrapperRef = useRef(null);

  useEffect(() => {
    // debugger;
    // setOptions(items);
    setOptions([...new Set(items)]);
  }, [setOptions, items]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    const { current: wrap } = wrapperRef;
    if (wrap && !wrap.contains(event.target)) {
      setDisplay(false);
    }
  };

  const setSelectedValue = (val) => {
    if (oldKeyward?.toLowerCase().trim() !== val?.toLowerCase().trim()) {
      swiperRef.current.swiper.slideTo(0);
    }

    setSearch(val);
    setKeyword(val);
    setDisplay(false);
    fetchDataByKeyward(val);
  };

  const handleReset = (val) => {
    swiperRef.current.swiper.slideTo(0);
    setSearch(defaultValue);
    setKeyword(defaultValue);
    setDisplay(false);
    fetchDataByKeyward(defaultValue);
  };

  const handleClear = (val) => {
    swiperRef.current.swiper.slideTo(0);
    setSearch("");
    setKeyword("");
    // setDisplay(false);
    // fetchDataByKeyward(defaultValue);
  };
  //https://www.youtube.com/watch?v=vXO5JMiKtM8
  return (
    <div ref={wrapperRef} className="SearchableDropdown">
      <label>Search your favorite category:</label>
      <div className="auto">
        <input
          className="SearchableDropdown_input"
          placeholder="Type to search"
          onClick={() => setDisplay(!display)}
          onChange={(e) => setSearch(e.target.value)}
          value={search}
        />
        <div className="wrap-close flex-it flex-align-item-center flex-justify-end">
          {search !== defaultValue && (
            <div className="closeSearch" onClick={() => handleReset()}>
              Reset
            </div>
          )}
          <div className="closeSearch" onClick={() => handleClear()}>
            Clear
          </div>
        </div>

        {display && (
          <div className="SearchableDropdown_results">
            {options
              .filter(
                (lbl) =>
                  lbl?.category_name
                    ?.toLowerCase()
                    .trim()
                    .indexOf(search?.toLowerCase().trim()) > -1 &&
                  lbl?.category_name?.toLowerCase().trim() !== "aaaa" &&
                  lbl?.category_name?.toLowerCase().trim() !== "bbbb" &&
                  lbl?.category_name?.trim() !== "Canned Food1" &&
                  lbl?.category_name?.trim() !== "Nut & Kernel1" &&
                  lbl?.category_name?.trim() !== "Dried Fruit1" &&
                  lbl?.category_name?.trim() !== "Giftcard1" &&
                  lbl?.category_name?.trim() !== "Grain Products1" &&
                  lbl?.category_name?.trim() !== "Coffee1" &&
                  lbl?.category_name?.trim() !== "Mobile Phone Recharge1111" &&
                  lbl?.category_name?.trim() !==
                    "Dried Goods / Local Specialties1" &&
                  // lbl?.category_name?.toLowerCase().trim() !==
                  //   "Novelty & Special Use".toLowerCase().trim() &&
                  lbl?.category_name?.toLowerCase().trim().indexOf("test") ===
                    -1
              )
              .map((option, index) => {
                return (
                  <div
                    className="SearchableDropdown_item"
                    key={index}
                    tabIndex="0"
                    onClick={() => setSelectedValue(option.category_name)}
                  >
                    {option.category_name}
                  </div>
                );
              })}
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomAutoComplete;
